import React from 'react'

// Material UI Components
import { makeStyles, List, ListItem, ListItemAvatar, Avatar, Button, Icon, ListItemText, DialogContent, DialogActions } from '@material-ui/core';

// Material UI Custom Component Style
const useStyles = makeStyles(theme => ({
    Selected: {
        background: theme.palette.primary.main,
        color: theme.palette.common.white,
        '&:hover' : {
            background: theme.palette.primary.main,
            color: theme.palette.common.white,
        }
    },
    Avatar: {
      width: theme.spacing(6),
      height: theme.spacing(6),
      background: theme.palette.grey[300]
    },
  }));

export default function Edit( { cardType, cardTypes, random, onClickSelectCard, handleDialogClose } ) {
    const Style = useStyles();

    return (
        <React.Fragment>
            <DialogContent style={{maxHeight: '500px'}}>
                <List>
                    {
                        cardTypes.map(card => {
                            return(
                                <ListItem 
                                    key={card.id} 
                                    button 
                                    className={cardType !== null && cardType.index === card.index ? Style.Selected : cardType === null && card.index === 0 ? Style.Selected : ""}
                                    onMouseDown={handleDialogClose}
                                    onClick={() => onClickSelectCard(card)}>
                                    <ListItemAvatar>
                                        <Avatar alt={card.title} className={Style.Avatar} variant="rounded">
                                            <Icon 
                                                className={
                                                    card.title === "Brands"
                                                        ? `fab ${card.icons[random]}`
                                                            : `fas ${card.icons[random]}`
                                                    } 
                                                style={{width: 'auto'}} 
                                                color="primary" />
                                        </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText primary={card.title} variant="h1" />
                                </ListItem>
                            );
                        })
                    }
                </List>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDialogClose} color="inherit">
                        Cancel
                    </Button>
                    <Button onClick={() => onClickSelectCard(cardTypes[random])} color="primary" variant="contained">
                        Random
                    </Button>
                </DialogActions>
        </React.Fragment>
    )
}
